import { z } from "zod";
export const registerPushTokenInputSchema = z.object({
    deviceId: z.string().trim().min(1),
    platform: z.literal("ios"),
    token: z.string().trim().min(1),
    environment: z.enum(["sandbox", "production"]),
    appVersion: z.string().trim().min(1).optional(),
});
export const pushTokenRegistrationSchema = z.object({
    id: z.string(),
    deviceId: z.string(),
    platform: z.literal("ios"),
    environment: z.enum(["sandbox", "production"]),
    appVersion: z.string().nullable(),
    lastSeenAt: z.number(),
});
export const registerPushTokenResponseSchema = z.object({
    pushToken: pushTokenRegistrationSchema,
});
export const unregisterPushTokenResponseSchema = z.object({
    ok: z.literal(true),
});
